import { useState } from "react";

export const PARTNER_LOGOS = [
  { name: "Microsoft", logo: "/img/partners/microsoft.png" },
  { name: "Best Buy", logo: "/img/partners/bestbuy.png" },
  { name: "Boys & Girls Club", logo: "/img/partners/bgca.png" },
  { name: "YMCA", logo: "/img/partners/ymca.png" },
  { name: "Atlanta Public Library", logo: null },
  { name: "Champions", logo: null },
  { name: "Henry County Parks & Rec", logo: null },
  { name: "Douglasville Parks & Rec", logo: null },
  { name: "East Point Parks & Rec", logo: null },
  { name: "Clayton County Parks & Rec", logo: null },
  { name: "Pinnacle Bank", logo: "/img/partners/pinnacle.png" },
  { name: "Atlanta Postal Credit Union", logo: "/img/partners/apcu.png" },
];

export function PartnerLogo({ p }) {
  const [err, setErr] = useState(!p.logo);
  const slug = p.name.toLowerCase().replace(/[^a-z0-9]+/g, "-");
  return (
    <div
      data-testid={`partner-logo-${slug}`}
      className="flex items-center justify-center h-20 rounded-2xl border border-slate-100 bg-white px-5 shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md"
    >
      {err ? (
        <span className="font-display font-bold text-brandnavy text-sm text-center leading-tight">{p.name}</span>
      ) : (
        <img
          src={p.logo}
          alt={`${p.name} logo`}
          onError={() => setErr(true)}
          className="max-h-10 max-w-[130px] object-contain transition"
          loading="lazy"
        />
      )}
    </div>
  );
}

export default function PartnerLogos({ columns = "grid-cols-2 sm:grid-cols-3 lg:grid-cols-5" }) {
  return (
    <div className={`grid ${columns} gap-4`} data-testid="partner-logos">
      {PARTNER_LOGOS.map((p) => (
        <PartnerLogo key={p.name} p={p} />
      ))}
    </div>
  );
}
